import { createScenariosSimulatorApiClient } from './api-client';
import { ConsumptionTypeEnum } from '@schemas/scenarios-simulator/enums';

/**
 * Consumption history types
 * Note: ConsumptionTypeEnum is now imported from centralized enums.ts
 */
export { ConsumptionTypeEnum };

export interface ConvertConsumptionHistoryParams {
  base_consumption_type: ConsumptionTypeEnum;
  target_consumption_type: ConsumptionTypeEnum;
  consumption_history: Record<string, any>;
}

export interface ConvertConsumptionHistoryResponse {
  data: Record<string, any>;
}

/**
 * Converts consumption history from one type to another
 *
 * @param params - Conversion parameters
 * @param token - Bearer authentication token
 * @returns Promise with converted consumption history
 */
export async function convertConsumptionHistory(
  params: ConvertConsumptionHistoryParams,
  token: string,
): Promise<Record<string, any>> {
  const apiClient = createScenariosSimulatorApiClient(token);
  const response = await apiClient.post<ConvertConsumptionHistoryResponse>('/v1/converters/consumption-history', {
    base_consumption_type: params.base_consumption_type,
    target_consumption_type: params.target_consumption_type,
    consumption_history: params.consumption_history,
  });
  return response.data.data;
}
